import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IServerAdminSettings } from '../../../settings/types/ISite';

export interface IUpdateSiteSettingsForServerAdminParams {
  id: string;
  settings: IServerAdminSettings;
}

export interface IUpdateSiteSettingsForServerAdminResult {
}

export class UpdateSiteSettingsForServerAdminRequest extends Request<IUpdateSiteSettingsForServerAdminParams, IUpdateSiteSettingsForServerAdminResult> {
  constructor(params: IUpdateSiteSettingsForServerAdminParams) {
    super('updateSiteSettingsForServerAdmin', params);
  }
}
